import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description RoundPlus icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { RoundPlus } from '@sravni/design-system-icons'
 *
 * <RoundPlus />
 * ```
 */
var RoundPlus = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "RoundPlus", viewBox: "0 0 21 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("g", { clipPath: "url(#RoundPlus__a)", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" },
        React.createElement("path", { d: "M10.737 17.143a7.143 7.143 0 1 0 0-14.286 7.143 7.143 0 0 0 0 14.286ZM10.736 7.143v5.714M7.879 10h5.714" })),
    React.createElement("defs", null,
        React.createElement("clipPath", { id: "RoundPlus__a" },
            React.createElement("path", { fill: "currentColor", transform: "translate(.736)", d: "M0 0h20v20H0z" }))))); });

export { RoundPlus };
//# sourceMappingURL=RoundPlus.js.map
